import React from "react";
import { OnsLargeLogo } from "../../Icons/Logos/OnsLargeLogo";
export interface Props {
  id: string;
  dataTestId: string;
}
export const Footer = (props: Props) => {
  return (
    <footer id={props.id} className="ons-footer" data-testid={props.dataTestId}>
      <div className="ons-footer__body" data-analytics="footer">
        <div className="ons-container ons-container--wide">
          <div className="ons-grid"></div>
          <div className="ons-grid ons-grid--flex ons-grid--vertical-top ons-grid--between">
            <div className="ons-grid__col">
              <a
                className="ons-footer__poweredBy-link"
                href="https://www.ons.gov.uk/"
              >
                <div className="ons-footer__poweredby-logo ons-u-mb-m">
                  {OnsLargeLogo}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
